import { createContext } from "react";
import { IMachineCenterContext } from "./MachineCenterInterfaces";
import {
    getCurrentStartBelowTriggerDowntimeCount,
    getCurrentStartDowntime,
    getIsDowntimeDetailsInput,
    getSplitInProgress,
    isUptimeActive,
    isPlcDisconnected,
} from "../../utilities/storageUtilities";

const uptime = isUptimeActive();
const currentStartDowntimeBelowTrigger = getCurrentStartBelowTriggerDowntimeCount();
const currentStartDowntime = getCurrentStartDowntime();
const isDowntimeDetailsInput = getIsDowntimeDetailsInput();
const plcDisconnected = isPlcDisconnected();
const splitInProgress = getSplitInProgress();

export const initialState: IMachineCenterContext = {
    machineStatus: uptime,
    handleMachineStatus: () => {},
    downtimeCounter: !uptime && currentStartDowntime ? true : false,
    handleDowntimeCounter: () => {},
    handleResetMachineCenterContext: () => {},
    downtimeCounterBelowTrigger: currentStartDowntimeBelowTrigger ? true : false,
    handleDowntimeCounterBelowTrigger: () => {},
    plc: !plcDisconnected,
    handlePlc: () => {},
    continueDowntimeDetailsInput: Boolean(isDowntimeDetailsInput),
    handleContinueDowntimeDetailsInput: (value: boolean) => {},
    splitInProgress: splitInProgress,
    handleSplitInProgress: (value: boolean) => {},
};

export const MachineCenterContext = createContext(initialState);
